module.exports = __webpack_public_path__ + "static/media/stockhausen_hbk_03.26ab2ad2.jpg";